import React, { useContext, useState, useEffect } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import AuthContext from '../../../../context/auth-context'
import mLaporan from '../Laporan.controler'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/moment';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone'
import PageviewIcon from '@material-ui/icons/Pageview';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import { stableSort, getSorting } from '../../../../Helper/Sorting'
import PropTypes from "prop-types";
import { TableSortLabel } from '@material-ui/core';
import numberWithCommas from '../../../../Helper/numberWithCommas'
import { FaChevronLeft } from 'react-icons/fa';
import SubKategoriDet from './SubKategori.Detail'

const Salesman = (props) => {
    const classes = useStyles();
    const [isRefresh, setIsRefresh] = useState(true)
    const [tglDari, setTglDari] = useState(props.tanggalDari)
    const [tglSampai, setTglSampai] = useState(props.tanggalSampai)
    const { clientID, token, userLogin } = useContext(AuthContext);
    const [idOutlet, setIdOutlet] = useState(props.idOutlet)
    const [listLaporan, setListLaporan] = useState([])
    const [order, setOrder] = React.useState("desc");
    const [orderBy, setOrderBy] = React.useState("jumlah");
    const [isDetail, setIsDetail] = useState(false)
    const [subKat, setSubKat] = useState({})
    const [listLaporanBarang, setListLaporanBarang] = useState([])
    var totJumlah = 0, totQty = 0;
    const [listLaporanDet, setListLaporanDet] = useState([])
    useEffect(() => {
        var render = true
        if (isRefresh) {
            mLaporan.laporanSubKategori(clientID, token, userLogin, idOutlet, tglDari, tglSampai).then(resp => {
                setListLaporan(resp.paymentPerSubKat)
                setListLaporanBarang(resp.itemPaymentGroupBarang)
            }).catch(err => {
                console.error(err);
            }).finally(() => setIsRefresh(false))
        }
        return () => {
            render = false
        };
    }, [isRefresh])


    const lihatLaporan = () => {
        setListLaporan([])
        setIsRefresh(true)
    }
    const handleChangeTglDari = (ev) => {
        setTglDari(ev)
    }
    const handleChangeTglSampai = (ev) => {
        setTglSampai(ev)
    }
    const namaExport = () => {
        return (
            <React.Fragment>
                <ImportExportIcon />  Export Excel
            </React.Fragment>
        )
    }
    const headRows = [
        { id: "namasubkategori", label: "Nama Sub Kategori" },
        { id: "qty", label: "Qty" },
        { id: "jumlah", label: "Jumlah" },

    ];
    const EnhancedTableHead = (props) => {
        const {
            order,
            orderBy,
            onRequestSort,
        } = props;
        const createSortHandler = property => event => {
            onRequestSort(event, property);
        };
        return (

            <thead>
                <tr className="colorWhite bgHeaderTabel tabelCenter">
                    <th style={{ "width": "15px" }}>Detail</th>
                    {headRows.map(row => (
                        <th key={row.id} >
                            <TableSortLabel
                                active={orderBy === row.id}
                                direction={order}
                                onClick={createSortHandler(row.id)}
                            >
                                {row.label}
                            </TableSortLabel>
                        </th>
                    ))}
                </tr>
            </thead>
        );
    }
    EnhancedTableHead.propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        order: PropTypes.oneOf(["asc", "desc"]).isRequired,
        orderBy: PropTypes.string.isRequired
    };
    const handleRequestSort = (event, property) => {
        const isDesc = orderBy === property && order === "desc";
        setOrder(isDesc ? "asc" : "desc");
        setOrderBy(property);
    }
    const openDet = (data) => {
        setSubKat(data)
        setIsDetail(true)
        const lapDet = listLaporanBarang.filter(el => {
            return el.kodesubkategori === data.kodesubkategori
        })
        setListLaporanDet(lapDet)
    }

    return (
        <React.Fragment>
            {!isDetail ? (
                <React.Fragment>
                    <Row>
                        <Col xs={12} lg={5}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ marginTop: 20, marginBottom: 20 }}>
                                <KeyboardDatePicker
                                    fullWidth={true}
                                    margin="normal"
                                    id="tanggal"
                                    label="Tanggal Dari"
                                    format="DD-MM-YYYY"
                                    value={tglDari}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    onChange={handleChangeTglDari}
                                    ampm={false}
                                    disableFuture
                                />
                            </MuiPickersUtilsProvider>
                        </Col>
                        <Col xs={12} md={5}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} style={{ marginTop: 20, marginBottom: 20 }}>
                                <KeyboardDatePicker
                                    fullWidth={true}
                                    margin="normal"
                                    id="tanggal"
                                    label="Tanggal Sampai"
                                    format="DD-MM-YYYY"
                                    value={tglSampai}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    style={{ color: '#000 !important' }}
                                    onChange={handleChangeTglSampai}
                                    ampm={false}
                                />
                            </MuiPickersUtilsProvider>
                        </Col>
                        <Col xs={12} md={2} className="text-center"><br />
                            <Button variant="contained" color="primary" onClick={lihatLaporan}>Lihat</Button>
                        </Col>
                    </Row>
                    <Row className=" bodySessionDetail">
                        <Col xs={12} className="marginGrafik">
                            <ReactHTMLTableToExcel
                                className="buttonExportExcel"
                                table="laporanSubKategori"
                                filename={`Laporan Sub Kategori ${moment(tglDari).format("DD-MM-YYYY")} sampai ${moment(tglSampai).format("DD-MM-YYYY")}`}
                                sheet="Sheet1"
                                buttonText={namaExport()} />
                            <Table id="laporanSubKategori" striped bordered hover responsive="lg">
                                <EnhancedTableHead
                                    onRequestSort={handleRequestSort}
                                    order={order}
                                    orderBy={orderBy}
                                />
                                <tbody className={`${classes.contentBody}`}>
                                    {stableSort(listLaporan, getSorting(order, orderBy))
                                        .map((data, index) => {
                                            totJumlah += data.jumlah
                                            totQty += data.qty
                                            return (
                                                <tr className="colorWhite" key={index}>
                                                    <td>
                                                        <Button title="Detail" variant="contained" className="btnRiwayatTrans" onClick={openDet.bind(this, data)}><PageviewIcon /></Button>
                                                    </td>
                                                    <td>{data.namasubkategori}</td>
                                                    <td className="text-center">{data.qty}</td>
                                                    <td className="text-right">
                                                        {numberWithCommas(data.jumlah)}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    <tr className="colorWhite">
                                        <th className="text-center" colSpan="2">Total</th>
                                        <th  className="text-center">
                                            {totQty}
                                        </th>
                                        <th className="text-right">
                                            {numberWithCommas(totJumlah)}
                                        </th>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </React.Fragment>
            ) : (
                    <React.Fragment>
                        <Row>
                            <Col xs={12}>
                                <div className="fixHeaderModal">
                                    <h4 style={{ paddingBottom: 10 }} className="border-bottom btnBack" onClick={() => setIsDetail(false)}><FaChevronLeft className="btnBack" />Sub Kategori Detail</h4>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <p className="colorBlack">Nama Sub Kategori : <b>{subKat.namasubkategori}</b> <br />
                                    Tanggal Periode: {moment(tglDari).format("DD-MM-YYYY")} sampai {moment(tglSampai).format("DD-MM-YYYY")}</p>
                            </Col>
                        </Row>
                        <SubKategoriDet  listLaporanDet={listLaporanDet} tglDari={tglDari} tglSampai={tglSampai} namasubkategori={subKat.namasubkategori}/>
                    </React.Fragment>
                )}

            <Row className="marginGrafik"></Row>
        </React.Fragment>

    )
}


export default Salesman;
const useStyles = makeStyles(theme => ({
    contentBody: {
        height: window.innerHeight - 200,
    },
}));